import { createShorthandFactory } from '@flowio/react-helpers';
import Icon from './components/Icon';
var createIcon = createShorthandFactory(Icon, function (value) {
  return {
    iconName: typeof value === 'string' ? value : undefined
  };
});
export default createIcon;